import request from './adminRequest'

export const organizationApi = {
  listOrganization (params) {
    return request.get('/organizations', { params: params })
  },
  getOrganization (id) {
    return request.get('/organizations/' + id)
  },
  saveOrganization (data) {
    return request.post('/organizations', data)
  },
  updateOrganization (id, data) {
    return request.put('/organizations/' + id, data)
  },
  deleteOrganization (id) {
    return request.delete('/organizations/' + id)
  },
}

export default organizationApi
